import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { TEAMS_PLATFORM_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const transformAggTeamViewToLegacyTeam = (team) => {
	if (team == null) return null;

	return {
		id: team.jiraSuppliedTeamId || '',
		name: team.jiraSuppliedName || '',
		isVisible: team.jiraSuppliedVisibility || false,
		avatarUrl: team.jiraSuppliedAvatar?.xsmall || '',
		isVerified: team.jiraSuppliedIsVerified || false,
	};
};

export const transformAggTeamViewToLegacyField: FieldTransformer = (node) => {
	if (node.type !== TEAMS_PLATFORM_CF_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: transformAggTeamViewToLegacyTeam(node.selectedTeam),
		schema: {
			configuration: null,
			custom: TEAMS_PLATFORM_CF_TYPE,
			items: null,
			renderer: PLAIN_TEXT,
			system: null,
			type: 'team',
		},
	};
};
